import { Space } from "antd";
import React from "react";
import { Stack } from "react-bootstrap";
import { useCopy } from "@utils/hooks/useCopy";
import { Button } from "react-bootstrap";

export const LabelValue = (props) => {
  const {
    label,
    value,
    icon = null,
    copyValue = null,
    direction = "horizontal",
  } = props;

  const { handleCopy, ButtonIcon, copyState } = useCopy({ value: copyValue });

  return (
    <Stack direction={direction} gap={2} className="flex-wrap" {...props}>
      <Space align="middle">
        {icon}
        <p className="mb-0 text-md text-secondary">{label}:</p>
      </Space>
      <Space>
        <p className="mb-0 H5">{!value ? "-" : value}</p>
        {copyValue && !!value && (
          <CopyButton value={copyValue} onClick={handleCopy} {...{ copyState }}>
            {<ButtonIcon />}
          </CopyButton>
        )}
      </Space>
    </Stack>
  );
};

const CopyButton = (props) => {
  const { value, copyState, ...restProps } = props;

  return (
    <Button
      variant="secondary"
      className="btn-outline btn-xs btn-secondary btn-icon"
      disabled={copyState === "copying"}
      {...restProps}
    />
  );
};
